// The active CMS whatsapp_url setting is the opt-in. Never derive a link from
// the ordinary telephone number when the setting is absent or disabled.
export function whatsappLink(value) {
  if (typeof value !== 'string' || !value.trim()) return null;
  try {
    const url = new URL(value.trim());
    if (url.protocol !== 'https:' || url.username || url.password || url.port) return null;
    const phone = url.hostname === 'wa.me' && /^\/[1-9]\d{5,14}\/?$/.test(url.pathname);
    const send = ['api.whatsapp.com', 'www.whatsapp.com'].includes(url.hostname) &&
      url.pathname === '/send' && /^[1-9]\d{5,14}$/.test(url.searchParams.get('phone') || '');
    return phone || send ? url.href : null;
  } catch { return null; }
}

export function activeWhatsapp(settings = []) {
  return whatsappLink(settings.find(s => s.key === 'whatsapp_url' && s.isActive === true)?.value);
}
